import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import MessageInboxRoutes from "./MessageInboxRoutes";
import MessageSentRoutes from "./MessageSentRoutes";
import MessageScheduleRoutes from "./MessageScheduleRoutes";
import MessageTemplateRoutes from "./MessageTemplateRoutes";
import useHasPermission from "../../../Hooks/useHasPermission";
import { getPreBasePath, getPreBaseRoute } from "../../../../../components";
export const getMessageBasePath = () => "/app/messages";
const getMessageInboxBasePath = () => getMessageBasePath() + "/inbox";
const getMessageInboxNewBasePath = () => getMessageInboxBasePath() + "/new";
const getMessageSentBasePath = () => getMessageBasePath() + "/sent";
const getMessageSentNewBasePath = () => getMessageSentBasePath() + "/new";
const getMessageScheduleBasePath = () => getMessageBasePath() + "/schedules";
const getMessageScheduleNewBasePath = () => getMessageScheduleBasePath() + "/new";
const getMessageScheduleEditBasePath = () => getMessageScheduleBasePath() + "/edit";
const getMessageTemplateBasePath = () => getMessageBasePath() + "/templates";
const getMessageTemplateNewBasePath = () => getMessageTemplateBasePath() + "/new";
const getMessageTemplateEditBasePath = () => getMessageTemplateBasePath() + "/edit";
export const getMessageInboxPath = (virtualizedAppName) => {
    return getPreBasePath(virtualizedAppName) + getMessageInboxBasePath();
};
export const getMessageInboxRoute = () => getPreBaseRoute() + getMessageInboxBasePath();
export const getMessageInboxNewPath = (virtualizedAppName) => {
    return getPreBasePath(virtualizedAppName) + getMessageInboxNewBasePath();
};
export const getMessageInboxNewRoute = () => getPreBaseRoute() + getMessageInboxNewBasePath();
export const getMessageSentPath = (virtualizedAppName) => {
    return getPreBasePath(virtualizedAppName) + getMessageSentBasePath();
};
export const getMessageSentRoute = () => getPreBaseRoute() + getMessageSentBasePath();
export const getMessageSentNewPath = (virtualizedAppName) => {
    return getPreBasePath(virtualizedAppName) + getMessageSentNewBasePath();
};
export const getMessageSentNewRoute = () => getPreBaseRoute() + getMessageSentNewBasePath();
export const getMessageSentDetailPath = (id, virtualizedAppName) => id === null
    ? getPreBasePath(virtualizedAppName) + getMessageSentBasePath()
    : getPreBasePath(virtualizedAppName) + getMessageSentBasePath() + `/${id}`;
export const getMessageSchedulePath = (virtualizedAppName) => {
    return getPreBasePath(virtualizedAppName) + getMessageScheduleBasePath();
};
export const getMessageScheduleRoute = () => getPreBaseRoute() + getMessageScheduleBasePath();
export const getMessageScheduleNewPath = (virtualizedAppName) => {
    return "/aviso/" + virtualizedAppName + getMessageScheduleNewBasePath();
};
export const getMessageScheduleNewRoute = () => getPreBaseRoute() + getMessageScheduleNewBasePath();
export const getMessageScheduleEditRoute = () => getPreBaseRoute() + getMessageScheduleEditBasePath();
export const getMessageScheduledDetailView = (id, virtualizedAppName) => id === null
    ? getPreBasePath(virtualizedAppName) + getMessageScheduleBasePath()
    : getPreBasePath(virtualizedAppName) +
        getMessageScheduleBasePath() +
        `/${id}`;
export const getMessageScheduledEditView = (id, virtualizedAppName) => id === null
    ? getPreBasePath(virtualizedAppName) + getMessageScheduleBasePath()
    : getPreBasePath(virtualizedAppName) +
        getMessageScheduleEditBasePath() +
        `/${id}`;
export const getMessageTemplatePath = (virtualizedAppName) => {
    return getPreBasePath(virtualizedAppName) + getMessageTemplateBasePath();
};
export const getMessageTemplateRoute = () => getPreBaseRoute() + getMessageTemplateBasePath();
export const getMessageTemplateNewPath = (virtualizedAppName) => {
    return getPreBasePath(virtualizedAppName) + getMessageTemplateNewBasePath();
};
export const getMessageTemplateNewRoute = () => getPreBaseRoute() + getMessageTemplateNewBasePath();
export const getMessageTemplateEditRoute = () => getPreBaseRoute() + getMessageTemplateEditBasePath();
export const getMessageTemplateDetailView = (params) => {
    return params.id === null
        ? getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getMessageTemplateBasePath()
        : getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
            getMessageTemplateBasePath() +
            `/${params.id}`;
};
export const getMessageTemplateEditView = (params) => {
    return params.id === null
        ? getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
            getMessageTemplateEditBasePath()
        : getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
            getMessageTemplateEditBasePath() +
            `/${params.id}`;
};
export const getMessageInboxDetailPath = (params) => {
    return params.threadId == null
        ? getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getMessageInboxBasePath()
        : getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
            getMessageInboxBasePath() +
            `/${params.threadId}`;
};
const MessageRoutes = (props) => {
    const canCreateTasks = useHasPermission("CAN_CREATE_SCHEDULED_MESSAGES");
    return (_jsxs(Switch, { children: [_jsx(Route, { render: () => _jsx(MessageSentRoutes, Object.assign({}, props)), path: getMessageSentRoute() }), canCreateTasks && (_jsx(Route, { render: () => _jsx(MessageScheduleRoutes, {}), path: getMessageScheduleRoute() })), _jsx(Route, { render: () => _jsx(MessageTemplateRoutes, {}), path: getMessageTemplateRoute() }), _jsx(Route, { render: () => _jsx(MessageInboxRoutes, Object.assign({}, props)), path: getMessageInboxRoute() }), _jsx(Route, { component: () => _jsx(Redirect, { to: getMessageInboxPath() }) })] }));
};
export default MessageRoutes;
